import { render } from "./ArticleCardHome.vue?vue&type=template&id=36b1ba2a&scoped=true"
import script from "./ArticleCardHome.vue?vue&type=script&lang=js"
export * from "./ArticleCardHome.vue?vue&type=script&lang=js"

import "./ArticleCardHome.vue?vue&type=style&index=0&id=36b1ba2a&scoped=true&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36b1ba2a"]])

export default __exports__